(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    const batchSize = 6;

    function setup(section) {
      if (!section) return;

      const items = Array.from(section.querySelectorAll('[data-blog-item]'));
      const button = section.querySelector('[data-blog-view-more-button]');

      if (!button || !items.length) return;

      if (section.dataset.blogViewMoreReady === 'true') return;
      section.dataset.blogViewMoreReady = 'true';
      section.dataset.blogVisibleCount = String(batchSize);

      items.forEach((item, index) => {
        item.hidden = index >= batchSize;
      });

      if (items.length <= batchSize) {
        button.hidden = true;
      }
    }

    function setupAll() {
      document.querySelectorAll('[data-blog-view-more]').forEach(setup);
    }

    setupAll();

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-blog-view-more-button]');
      if (!button) return;

      const section = button.closest('[data-blog-view-more]');
      if (!section) return;

      const items = Array.from(section.querySelectorAll('[data-blog-item]'));
      let visibleCount = Number(section.dataset.blogVisibleCount || batchSize);
      visibleCount += batchSize;
      section.dataset.blogVisibleCount = String(visibleCount);

      items.forEach((item, index) => {
        item.hidden = index >= visibleCount;
      });

      if (visibleCount >= items.length) {
        button.hidden = true;
      }
    });

    document.addEventListener('shopify:section:load', (event) => {
      setup(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
